import React, { useState } from "react";
import { data } from "../data";
import { MathComponent } from "mathjax-react";
import DoubleArrowIcon from "@material-ui/icons/DoubleArrow";
import SkipNextIcon from "@material-ui/icons/SkipNext";
import SkipPreviousIcon from "@material-ui/icons/SkipPrevious";
import { InlineMath } from "react-katex";
import Iframe from "react-iframe";
import Ch4 from "../3/Ch4.js";
import MediaQuery from "react-responsive";
import Chtambahan from "./Chtambahan";

const Part3 = () => {

	const [chsoal0, setChsoal0] = useState(false);
	const clickSetChSoal0 = () => setChsoal0(!chsoal0);
	const [chsoal1, setChsoal1] = useState(false);
	const clickSetChSoal1 = () => setChsoal1(!chsoal1);
	const [chsoal2, setChsoal2] = useState(false);
	const clickSetChSoal2 = () => setChsoal2(!chsoal2);
	const [jawaban1, setJawaban1] = useState(false);
	const clickSetJawaban1 = () => setJawaban1(!jawaban1);
	const [jawaban2, setJawaban2] = useState(false);
	const clickSetJawaban2 = () => setJawaban2(!jawaban2);
	const [jawaban3, setJawaban3] = useState(false);
	const clickSetJawaban3 = () => setJawaban3(!jawaban3);
	const [chsoal3, setChsoal3] = useState(false);
	const clickSetChSoal3 = () => setChsoal3(!chsoal3);

	const [chsoal4, setChsoal4] = useState(false);
	const clickSetChSoal4 = () => setChsoal4(!chsoal4);

	const { subbab3, materi3 } = data[2];
	const [showbaru1, setShowbaru1] = useState(false);
	const [showbaru2, setShowbaru2] = useState(false);
	const [showbaru3, setShowbaru3] = useState(false);
	const [showbaru4, setShowbaru4] = useState(false);
	const [showbaru4new, setShowbaru4new] = useState(false);
	const [showbaru5, setShowbaru5] = useState(false);
	const [showbaru6, setShowbaru6] = useState(false);
	const [showbaru7, setShowbaru7] = useState(false);
	const [showbaru7new, setShowbaru7new] = useState(false);

	//partakhirlatihan1
	const [showbaru9, setShowbaru9] = useState(false);
	const [showbaru10, setShowbaru10] = useState(false);
	const [showbaru11, setShowbaru11] = useState(false);
	const [showbaru11new, setShowbaru11new] = useState(false);

	//latihan3
	const [true1,setTrue1] = useState(false);
	const [true2,setTrue2] = useState(false);
	const [true3,setTrue3] = useState(false);
	const [true4,setTrue4] = useState(false);
	const [true5,setTrue5] = useState(false);
	const [true6,setTrue6] = useState(false);
	const [true7,setTrue7] = useState(false);
	const [true8,setTrue8] = useState(false);
	const [true9,setTrue9] = useState(false);
	const [true10,setTrue10] = useState(false);
	const [show4, setShow4] = useState(false);
	const [show5, setShow5] = useState(false);
	const [show6, setShow6] = useState(false);
	const [show7, setShow7] = useState(false);
	const [show8, setShow8] = useState(false);

	// const [show1, setShow1] = useState(false);
	const [show2, setShow2] = useState(false);
	const [show2new, setShow2new] = useState(false);
	// const [form1, setForm1] = useState({ width: "50px", height: "30px" });
	// const [form2, setForm2] = useState({ width: "50px", height: "30px" });
	const [form3, setForm3] = useState({ width: "50px", height: "30px" });
	const [form4, setForm4] = useState({ width: "50px", height: "30px" });
	const [form5, setForm5] = useState({ width: "50px", height: "30px" });
	const [form5new, setForm5new] = useState({ width: "50px", height: "30px" });
	const [form6, setForm6] = useState({ width: "50px", height: "30px" });
	const [form7, setForm7] = useState({ width: "50px", height: "30px" });
	const [form8, setForm8] = useState({ width: "50px", height: "30px" });
	const [form8new, setForm8new] = useState({ width: "50px", height: "30px" });
	const [tab1, setTab1] = useState({ width: "50px", height: "30px" });
	const [tab2, setTab2] = useState({ width: "50px", height: "30px" });
	const [tab3, setTab3] = useState({ width: "50px", height: "30px" });
	const [tab4, setTab4] = useState({ width: "50px", height: "30px" });
	const [tab5, setTab5] = useState({ width: "50px", height: "30px" });
	const [tab5new, setTab5new] = useState({ width: "50px", height: "30px" });
	const [tab6, setTab6] = useState({ width: "50px", height: "30px" });
	const [tab7, setTab7] = useState({ width: "50px", height: "30px" });
	const [tab8, setTab8] = useState({ width: "50px", height: "30px" });
	const [tab9, setTab9] = useState({ width: "50px", height: "30px" });
	const [tab10, setTab10] = useState({ width: "50px", height: "30px" });
	const [tab10new, setTab10new] = useState({ width: "50px", height: "30px" });

	const [threenew1, setThreenew1] = useState({ width: "50px", height: "30px" });
	const [threenew2, setThreenew2] = useState({ width: "50px", height: "30px" });
	const [threenew3, setThreenew3] = useState({ width: "50px", height: "30px" });
	const [three1, setThree1] = useState({ width: "50px", height: "30px" });
	const [three2, setThree2] = useState({ width: "50px", height: "30px" });
	const [three3, setThree3] = useState({ width: "50px", height: "30px" });
	const [three4, setThree4] = useState({ width: "50px", height: "30px" });
	const [three5, setThree5] = useState({ width: "50px", height: "30px" });
	const [three6, setThree6] = useState({ width: "50px", height: "30px" });
	const [three7, setThree7] = useState({ width: "50px", height: "30px" });
	const [three8, setThree8] = useState({ width: "50px", height: "30px" });
	const [three9, setThree9] = useState({ width: "50px", height: "30px" });
	const [three10, setThree10] = useState({ width: "50px", height: "30px" });
	const [three11, setThree11] = useState({ width: "50px", height: "30px" });
	const [three12, setThree12] = useState({ width: "50px", height: "30px" });
	const [three13, setThree13] = useState({ width: "60px", height: "30px" });
	const [three14, setThree14] = useState({ width: "60px", height: "30px" });
	const handthreenew1 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "3") {
			setThreenew1({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			})
			setTrue3(true)
		} else if (jwb === "") {
			setThreenew1({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setThreenew1({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handthreenew2 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "2") {
			setThreenew2({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			})
			setTrue4(true)
		} else if (jwb === "") {
			setThreenew2({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setThreenew2({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handthreenew3 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "12") {
			setThreenew3({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			})
			setTrue5(true)
		} else if (jwb === "") {
			setThreenew3({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setThreenew3({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handthree1 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "4") {
			setThree1({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setThree1({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setThree1({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handthree2 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setThree2({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			})
			setTrue1(true)
		} else if (jwb === "") {
			setThree2({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setThree2({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handthree3 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setThree3({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setThree3({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setThree3({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handthree4 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "6") {
			setThree4({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			})
			setTrue2(true)
		} else if (jwb === "") {
			setThree4({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setThree4({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handthree5 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "24") {
			setThree5({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			})
			setTrue6(true)
		} else if (jwb === "") {
			setThree5({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setThree5({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handthree6 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setThree6({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			})
			setTrue7(true)
		} else if (jwb === "") {
			setThree6({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setThree6({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handthree7 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "8") {
			setThree7({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			})
			setTrue8(true)
		} else if (jwb === "") {
			setThree7({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setThree7({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handthree8 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "4") {
			setThree8({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			})
			setTrue9(true)
		} else if (jwb === "") {
			setThree8({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setThree8({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handthree9 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setThree9({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			})
			setTrue10(true)
		} else if (jwb === "") {
			setThree9({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setThree9({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handthree10 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "32") {
			setShow4(true);
			setThree10({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setThree10({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setThree10({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handthree11 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "2") {
			setShow5(true);
			setThree11({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setThree11({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setThree11({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handthree12 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "8") {
			setShow6(true);
			setThree12({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setThree12({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setThree12({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handthree13 = (no1) => {
		const jwb = no1.target.value;
		if (jwb.toUpperCase() === "BENAR") {
			setShow7(true);
			setThree13({
				width: "60px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setThree13({
				width: "60px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setThree13({
				width: "60px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handthree14 = (no1) => {
		const jwb = no1.target.value;
		if (jwb.toUpperCase() === "BENAR") {
			setShow8(true);
			setThree14({
				width: "60px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setThree14({
				width: "60px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setThree14({
				width: "60px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handtab1 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "3") {
			setTab1({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setTab1({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setTab1({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handtab2 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setTab2({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setTab2({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setTab2({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handtab3 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setTab3({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
			setShowbaru2(true);
		} else if (jwb === "") {
			setTab3({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setTab3({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handtab4 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "2") {
			setTab4({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
			setShowbaru3(true);
		} else if (jwb === "") {
			setTab4({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setTab4({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handtab5 = (no1) => {
		const jwb = no1.target.value;
		if (jwb=== "3,0") {
			setTab5({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
			setShowbaru4(true);
		} else if (jwb === "") {
			setTab5({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setTab5({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handtab5new = (no1) => {
		const jwb = no1.target.value;
		if (jwb=== "0,2") {
			setTab5new({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
			setShowbaru4new(true);
		} else if (jwb === "") {
			setTab5new({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setTab5new({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handtab6 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "1") {
			setTab6({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setTab6({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setTab6({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handtab7 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setTab7({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setTab7({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setTab7({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handtab8 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setTab8({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
			setShowbaru5(true);
		} else if (jwb === "") {
			setTab8({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setTab8({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handtab9 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "-1") {
			setTab9({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
			setShowbaru6(true);
		} else if (jwb === "") {
			setTab9({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setTab9({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handtab10 = (no1) => {
		const jwb = no1.target.value;
		if (jwb==="1,0") {
			setTab10({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
			setShowbaru7(true);
		} else if (jwb === "") {
			setTab10({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setTab10({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handtab10new = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0,-1") {
			setTab10new({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
			setShowbaru7new(true);
		} else if (jwb === "") {
			setTab10new({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setTab10new({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};

	// const handForm1 = (no1) => {
	// 	const jwb = no1.target.value;
	// 	if (jwb === "10") {
	// 		setForm1({
	// 			width: "50px",
	// 			height: "30px",
	// 			border: "6px solid #1aff66",
	// 		});
	// 	} else if (jwb === "") {
	// 		setForm1({
	// 			width: "50px",
	// 			height: "30px",
	// 			border: "6px solid yellow",
	// 		});
	// 	} else {
	// 		setForm1({
	// 			width: "50px",
	// 			height: "30px",
	// 			border: "6px solid red",
	// 		});
	// 	}
	// };
	// const handForm2 = (no1) => {
	// 	const jwb = no1.target.value;
	// 	if (jwb === "-5") {
	// 		// setShow1(true);
	// 		setForm2({
	// 			width: "50px",
	// 			height: "30px",
	// 			border: "6px solid #1aff66",
	// 		});
	// 	} else if (jwb === "") {
	// 		setForm2({
	// 			width: "50px",
	// 			height: "30px",
	// 			border: "6px solid yellow",
	// 		});
	// 	} else {
	// 		setForm2({
	// 			width: "50px",
	// 			height: "30px",
	// 			border: "6px solid red",
	// 		});
	// 	}
	// };
	const handForm3 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setForm3({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setForm3({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setForm3({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handForm4 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "5") {
			setForm4({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
			setShowbaru1(true);
		} else if (jwb === "") {
			setForm4({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setForm4({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handForm5new = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "2,5 ,0") {
			setShow2new(true);
			setForm5new({
				width: "60px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setForm5new({
				width: "60px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setForm5new({
				width: "60px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handForm5 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0,5") {
			setShow2(true);
			setForm5({
				width: "60px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setForm5({
				width: "60px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setForm5({
				width: "60px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handForm6 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "6") {
			setShowbaru9(true);
			setForm6({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setForm6({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setForm6({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handForm7 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "3") {
			setShowbaru10(true);
			setForm7({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setForm7({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setForm7({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handForm8 = (no1) => {
		const jwb = no1.target.value;
		if (jwb=== "6,0") {
			setShowbaru11(true);
			setForm8({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setForm8({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setForm8({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handForm8new = (no1) => {
		const jwb = no1.target.value;
		if (jwb=== "0,3") {
			setShowbaru11new(true);
			setForm8new({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setForm8new({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setForm8new({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const [ukuranH,setUkuranH]=useState(19)
	const [ukuranP,setUkuranP]=useState(15)
	const sizeplus =()=>{
		setUkuranH(ukuranH+1)
		setUkuranP(ukuranP+1)
	}
	const sizemin =()=>{
		setUkuranH(ukuranH-1)
		setUkuranP(ukuranP-1)
	}
	return (
		<div className="container">
			<div className="d-flex justify-content-end">
			<button className="btnplus" onClick={sizeplus}><h6>A<sub>+</sub></h6></button>
			<button className="btnplus" onClick={sizemin}><h6>A<sub>-</sub></h6></button>
			</div>
			<div
				style={{
					width: "100%",
					textAlign: "justify",
					lineHeight: "35px",
				}}
			>
				<div
					style={{
						marginTop: "3rem",
						color: "green",
					}}
				>
					<strong style={{fontSize:`${ukuranH}px`}}>{subbab3}</strong>
				</div>
		
				<div style={{ textIndent: "2rem",fontSize:`${ukuranP}px` }}>
					Nah kali ini kita akan belajar mengenai{" "}
					<b>Sistem Pertidaksaamaan Linear Dua Variabel</b>&nbsp;{materi3}
				</div>
				<div style={{fontSize:`${ukuranP}px`}} className="text-center mt-2 mb-2">
					Agar lebih memahami mari perhatikan contoh di bawah ini!
				</div>
				<div className="d-grid gap-2">
					<button
						onClick={() => clickSetChSoal0()}
						className="btn btn-outline-success border-success shadow rounded mb-2"
					>
						{" "}
						<h6
							style={{
								animation: "scrollTop 0.3s alternate ease infinite",
							}}
						>
							Contoh Soal
						</h6>
					</button>
					<div>{chsoal0 ? <Chtambahan ukuranH={ukuranH} ukuranP={ukuranP} /> : null}</div>
				</div>
				<div className="text-center">
					Setelah membaca dan memahami contoh soal di atas, selanjutnya kerjakan
					latihan di bawah ini !
				</div>
				<div className="row">
					<div className="col">
						<div
							className="card mt-2 mb-2 border-success"
							style={{ borderRadius: "20px" }}
						>
							<div
								style={{ backgroundColor: "#40bf80", borderRadius: "20px" }}
								className="card-header"
							>
								<h6 className="text-white text-center">Petunjuk Pengerjaan</h6>
							</div>
							<div className="card-body">
								<ol>
									<li>Perhatikan dengan teliti !</li>
									<li>Kalian harus mengisi form yang kosong</li>
									<li>
										Apabila benar maka border form akan berwarna hijau, kemudian
										akan tampil lanjutannya
									</li>
									<li>Apabila salah maka border form akan berwarna merah</li>
								</ol>
							</div>
						</div>
					</div>
				</div>

				<div>
					<div className="d-grid gap-2">
						<button
							onClick={() => clickSetChSoal1()}
							className="btn btn-outline-primary btn-sm "
						>
							{" "}
							<h6
								style={{
									animation: "scrollTop 0.3s alternate ease infinite",
								}}
							>
								Latihan Soal 1
							</h6>
						</button>
					</div>
					{chsoal1 ? (
						<div>
							<div
								style={{
									margin: "auto",
									lineHeight: "35px",
									textAlign: "justify",
									width: "100%",
									borderStyle: "solid",
									borderColor: "#2d8659",
									borderRadius: "25px",
									boxShadow: "5px 5px #888887",
								}}
								className="mt-2"
							>
								<div
									style={{
										width: "80%",
										margin: "auto",
									}}
								>
									<div style={{ display: "flex", justifyContent: "center", fontSize:`${ukuranP}px` }}>
										<p>
											Tentukan Daerah Penyelesaian dari sistem
											pertidaksamaan dengan dua variabel &nbsp;&nbsp;
											<InlineMath math="4x + 2y ≤ 10; " />&nbsp;
											<InlineMath math="2x + 4y ≤ 12; " />&nbsp;
											&nbsp;untuk x dan y anggota R !
										</p>
									</div>
									<div
										style={{
											color: "green",
											display: "flex",
											justifyContent: "space-between",
											width: "10%",
										}}
									>
										<div
											style={{
												width: "5px",
												height: "5px",
												animation: "scrollTop 0.3s alternate ease infinite",
											}}
										>
											<SkipNextIcon />
										</div>
										<p
											style={{ marginLeft: "22px", cursor: "pointer" }}
											onClick={clickSetJawaban1}
										>
											<strong>
												<u>Jawaban</u>
											</strong>
										</p>
										<div
											style={{
												width: "5px",
												height: "5px",
												animation: "scrollTop 0.3s alternate ease infinite",
											}}
										>
											<SkipPreviousIcon />
										</div>
									</div>
									{jawaban1 ? (
										<div>
											<ul style={{fontSize:`${ukuranP}px`}}>
												<li>
													Pada <InlineMath math="4x + 2y ≤ 10 \space" />
													kita buat tabel, sehingga kita mendapatkan titik potong pada sumbu <InlineMath math=" x "/> dan titik potong pada sumbu <InlineMath math=" y \space"/>
												</li>
												<>
												<div className="d-flex justify-content-center"><InlineMath math="4x + 2y = 10"/> </div>
													<div class="d-flex justify-content-center">
														<table
															style={{
																border: "2px solid green",
																borderCollapse: "collapse",
																width: "30%",
																textAlign: "center",
															}}
														>
															<tr>
																<td
																	style={{
																		border: "2px solid green",
																		borderCollapse: "collapse",
																	}}
																>
																	<i>x</i>
																</td>
																<td
																	style={{
																		border: "2px solid green",
																		borderCollapse: "collapse",
																	}}
																>
																	<i>
																		<InlineMath math="2,5" />
																	</i>
																</td>
																<td
																	style={{
																		border: "2px solid green",
																		borderCollapse: "collapse",
																	}}
																>
																	<input
																		type="text"
																		onChange={handForm3}
																		style={form3}
																	/>
																</td>
															</tr>
															<tr>
																<td
																	style={{
																		border: "2px solid green",
																		borderCollapse: "collapse",
																	}}
																>
																	<i>y</i>
																</td>
																<td
																	style={{
																		border: "2px solid green",
																		borderCollapse: "collapse",
																	}}
																>
																	<i>0</i>
																</td>
																<td
																	style={{
																		border: "2px solid green",
																		borderCollapse: "collapse",
																	}}
																>
																	<input
																		type="text"
																		onChange={handForm4}
																		style={form4}
																	/>
																</td>
															</tr>
														</table>
													</div>
													{showbaru1 ? (
														<>
															<div className="text-center">
																Maka kita mendapatkan titik koordinat seperti
																tabel di bawah ini
															</div>
															<div className="d-flex justify-content-center">
																<table
																	style={{
																		border: "2px solid green",
																		borderCollapse: "collapse",
																		width: "30%",
																		textAlign: "center",
																	}}
																>
																	<tr>
																		<th>Koordinat (X,Y)</th>
																	</tr>
																	<tr>
																		<td
																			style={{
																				border: "2px solid green",
																				borderCollapse: "collapse",
																			}}
																		>
																			<i>(2,5 , 0)</i>
																		</td>
																	</tr>
																	<tr>
																		<td
																			style={{
																				border: "2px solid green",
																				borderCollapse: "collapse",
																			}}
																		>
																			<i>(0,5)</i>
																		</td>
																	</tr>
																</table>
															</div>
															<div className="d-flex justify-content-center">
																<p>Titik Koordinat A = (<input type="text" onChange={handForm5new} style={form5new} />)</p>
															</div>
															<div className="d-flex justify-content-center">
																<p>Titik Koordinat B = (<input type="text" onChange={handForm5} style={form5} />)</p>
															</div>
														
															{show2&&show2new ? (
																<>
																	<li>
																	Pada <InlineMath math="2x + 4y ≤ 12 \space" />
													kita buat tabel, sehingga kita mendapatkan titik potong pada sumbu <InlineMath math=" x "/> dan titik potong pada sumbu <InlineMath math=" y \space"/>:
																	</li>
																	<div className="d-flex justify-content-center"><InlineMath math="2x + 4y = 12"/> </div>
																	<div class="d-flex justify-content-center">
																		<table
																			style={{
																				border: "2px solid green",
																				borderCollapse: "collapse",
																				width: "30%",
																				textAlign: "center",
																			}}
																		>
																			<tr>
																				<td
																					style={{
																						border: "2px solid green",
																						borderCollapse: "collapse",
																					}}
																				>
																					<i>x</i>
																				</td>
																				<td
																					style={{
																						border: "2px solid green",
																						borderCollapse: "collapse",
																					}}
																				>
																					<input
																						type="text"
																						onChange={handForm6}
																						style={form6}
																					/>
																				</td>
																				<td
																					style={{
																						border: "2px solid green",
																						borderCollapse: "collapse",
																					}}
																				>
																					<i>
																						<InlineMath math="0" />
																					</i>
																				</td>
																			</tr>
																			<tr>
																				<td
																					style={{
																						border: "2px solid green",
																						borderCollapse: "collapse",
																					}}
																				>
																					<i>y</i>
																				</td>
																				<td
																					style={{
																						border: "2px solid green",
																						borderCollapse: "collapse",
																					}}
																				>
																					<i>0</i>
																				</td>
																				<td
																					style={{
																						border: "2px solid green",
																						borderCollapse: "collapse",
																					}}
																				>
																					<input
																						type="text"
																						onChange={handForm7}
																						style={form7}
																					/>
																				</td>
																			</tr>
																		</table>
																	</div>
																	{showbaru9 && showbaru10 ? (
																		<>
																			<div className="text-center">
																				Maka kita mendapatkan titik koordinat
																				seperti tabel di bawah ini
																			</div>
																			<div className="d-flex justify-content-center">
																				<table
																					style={{
																						border: "2px solid green",
																						borderCollapse: "collapse",
																						width: "30%",
																						textAlign: "center",
																					}}
																				>
																					<tr>
																						<th>Koordinat (X,Y)</th>
																					</tr>
																					<tr>
																						<td
																							style={{
																								border: "2px solid green",
																								borderCollapse: "collapse",
																							}}
																						>
																							<i>(6,0)</i>
																						</td>
																					</tr>
																					<tr>
																						<td
																							style={{
																								border: "2px solid green",
																								borderCollapse: "collapse",
																							}}
																						>
																							<i>(0,3)</i>
																						</td>
																					</tr>
																				</table>
																			</div>
																			<div className="d-flex justify-content-center">
																<p>Titik Koordinat C = (<input type="text" onChange={handForm8} style={form8} />)</p>
															</div>
															<div className="d-flex justify-content-center">
																<p>Titik Koordinat D = (<input type="text" onChange={handForm8new} style={form8new} />)</p>
															</div>																			
																			{showbaru11&&showbaru11new ? (
																				<>
																					<div className="alert alert-dark">
																					<p className="text-center">
																						Coba kamu kerjakan perintah yang ada
																						pada grafik di bawah ini !
																					</p>
																					<p><b>Catatan:</b> <i>Kalian bisa melakukan zoom seperti biasa</i></p>
																					</div>
																					<div className="d-flex justify-content-center mb-2">
																					<Iframe  scrolling="no" title="Latihan1akhirsptldv" src="https://www.geogebra.org/material/iframe/id/ytkkmzgs/width/810/height/717/border/888888/sfsb/true/smb/false/stb/false/stbh/false/ai/false/asb/false/sri/false/rc/false/ld/true/sdz/true/ctl/false" width="810px" height="700px" allowFullScreen/>
																					</div>
																				</>
																			) : null}
																		</>
																	) : null}
																</>
															) : null}
														</>
													) : null}
												</>
												{/* // ) : null} */}
											</ul>
										</div>
									) : null}
								</div>
							</div>
						</div>
					) : null}
				</div>

				<div className="d-grid gap-2">
					<button
						onClick={() => clickSetChSoal2()}
						className="btn btn-outline-success btn-sm mt-2"
					>
						{" "}
						<h6
							style={{
								animation: "scrollTop 0.3s alternate ease infinite",
							}}
						>
							Latihan Soal 2
						</h6>
					</button>
				</div>
				{/* HHHHH */}
				{chsoal2 ? (
					<div
						style={{
							margin: "auto",

							textAlign: "justify",
							width: "100%",
							borderStyle: "inset",
							borderColor: "green",
							borderRadius: "25px",
						}}
						className="mt-2"
					>
						<div style={{ width: "80%", margin: "auto" }}>
							<div style={{ position: "relative" }}>
								<p style={{fontSize:`${ukuranP}px`}} className="text-center">
									Tentukan daerah penyelesaian dari suatu sistem pertidaksamaan
									&nbsp;
									<InlineMath math="2x + 3y ≤ 6;" />
									&nbsp;
									<InlineMath math=" x - y ≤ 1 ;" />
								</p>
							</div>
							<div
								style={{
									color: "green",
									display: "flex",
									justifyContent: "space-between",
									width: "10%",
								}}
							>
								<div
									style={{
										width: "5px",
										height: "5px",
										animation: "scrollTop 0.3s alternate ease infinite",
									}}
								>
									<SkipNextIcon />
								</div>
								<p
									style={{ marginLeft: "22px", cursor: "pointer" }}
									onClick={clickSetJawaban2}
								>
									<strong>
										<u>Jawaban</u>
									</strong>
								</p>
								<div
									style={{
										width: "5px",
										height: "5px",
										animation: "scrollTop 0.3s alternate ease infinite",
									}}
								>
									<SkipPreviousIcon />
								</div>
							</div>
							{jawaban2 ? (
								<div>
									<div>
										<ol style={{fontSize:`${ukuranP}px`}}>
											<li>
																	Pada <InlineMath math="2x + 3y ≤ 6 \space" />
													kita buat tabel, sehingga kita mendapatkan titik potong pada sumbu <InlineMath math=" x "/> dan titik potong pada sumbu <InlineMath math=" y \space"/>:
												<div className="d-flex justify-content-center"><InlineMath math="2x + 3y = 6"/> </div>
												<div class="d-flex justify-content-center mb-2">
													<table
														style={{
															border: "2px solid green",
															borderCollapse: "collapse",
															width: "30%",
															textAlign: "center",
														}}
													>
														<tr>
															<td
																style={{
																	border: "2px solid green",
																	borderCollapse: "collapse",
																}}
															>
																<i>x</i>
															</td>
															<td
																style={{
																	border: "2px solid green",
																	borderCollapse: "collapse",
																}}
															>
																{/* 3 */}
																<input
																	type="text"
																	onChange={handtab1}
																	style={tab1}
																/>
															</td>
															<td
																style={{
																	border: "2px solid green",
																	borderCollapse: "collapse",
																}}
															>
																{/* 0 */}
																<input
																	type="text"
																	onChange={handtab2}
																	style={tab2}
																/>
															</td>
														</tr>
														<tr>
															<td
																style={{
																	border: "2px solid green",
																	borderCollapse: "collapse",
																}}
															>
																<i>y</i>
															</td>
															<td
																style={{
																	border: "2px solid green",
																	borderCollapse: "collapse",
																}}
															>
																{/* 0 */}
																<input
																	type="text"
																	onChange={handtab3}
																	style={tab3}
																/>
															</td>
															<td
																style={{
																	border: "2px solid green",
																	borderCollapse: "collapse",
																}}
															>
																{/* 2 */}
																<input
																	type="text"
																	onChange={handtab4}
																	style={tab4}
																/>
															</td>
														</tr>
													</table>
												</div>
												
												{showbaru2 && showbaru3 ? (
													<>
														<div className="d-flex justify-content-center">
															<table
																style={{
																	border: "2px solid green",
																	borderCollapse: "collapse",
																	width: "30%",
																	textAlign: "center",
																}}
															>
																<tr>
																	<th>Koordinat (X,Y)</th>
																</tr>
																<tr>
																	<td
																		style={{
																			border: "2px solid green",
																			borderCollapse: "collapse",
																		}}
																	>
																		<i>3,0</i>
																	</td>
																</tr>
																<tr>
																	<td
																		style={{
																			border: "2px solid green",
																			borderCollapse: "collapse",
																		}}
																	>
																		<i>0,2</i>
																	</td>
																</tr>
															</table>
														</div>
														<div className="d-flex justify-content-center">
																<p>Titik Koordinat A = (<input type="text" onChange={handtab5} style={tab5} />)</p>
															</div>
															<div className="d-flex justify-content-center">
																<p>Titik Koordinat B = (<input type="text" onChange={handtab5new} style={tab5new}  />)</p>
															</div>
														{showbaru4&&showbaru4new ? (
															<>
																<li>
															Pada <InlineMath math="x - y ≤ 1 \space" />
													kita buat tabel, sehingga kita mendapatkan titik potong pada sumbu <InlineMath math=" x "/> dan titik potong pada sumbu <InlineMath math=" y \space"/>:
												<div className="d-flex justify-content-center"><InlineMath math="x - y = 1"/> </div>
																	<div class="d-flex justify-content-center">
																		<table
																			style={{
																				border: "2px solid green",
																				borderCollapse: "collapse",
																				width: "30%",
																				textAlign: "center",
																			}}
																		>
																			<tr>
																				<td
																					style={{
																						border: "2px solid green",
																						borderCollapse: "collapse",
																					}}
																				>
																					<i>x</i>
																				</td>
																				<td
																					style={{
																						border: "2px solid green",
																						borderCollapse: "collapse",
																					}}
																				>
																					{/* 1 */}
																					<input
																						type="text"
																						onChange={handtab6}
																						style={tab6}
																					/>
																				</td>
																				<td
																					style={{
																						border: "2px solid green",
																						borderCollapse: "collapse",
																					}}
																				>
																					{/* 0 */}
																					<input
																						type="text"
																						onChange={handtab7}
																						style={tab7}
																					/>
																				</td>
																			</tr>
																			<tr>
																				<td
																					style={{
																						border: "2px solid green",
																						borderCollapse: "collapse",
																					}}
																				>
																					<i>y</i>
																				</td>
																				<td
																					style={{
																						border: "2px solid green",
																						borderCollapse: "collapse",
																					}}
																				>
																					{/* 0 */}
																					<input
																						type="text"
																						onChange={handtab8}
																						style={tab8}
																					/>
																				</td>
																				<td
																					style={{
																						border: "2px solid green",
																						borderCollapse: "collapse",
																					}}
																				>
																					{/* -1 */}
																					<input
																						type="text"
																						onChange={handtab9}
																						style={tab9}
																					/>
																				</td>
																			</tr>
																		</table>
																	</div>
																	{showbaru5 && showbaru6 ? (
																		<>
																				<div className="d-flex justify-content-center">
																<p>Titik Koordinat C = (<input type="text" onChange={handtab10} style={tab10} />)</p>
															</div>
															<div className="d-flex justify-content-center">
																<p>Titik Koordinat D = (<input type="text" onChange={handtab10new} style={tab10new}  />)</p>
															</div>
																			{showbaru7&&showbaru7new ? (
																				<>
																					<p className="text-center alert alert-dark">
																						Coba kamu kerjakan perintah yang ada
																						pada grafik di bawah ini !
																					</p>
																					<div className="d-flex justify-content-center">	
																					<Iframe
																					  scrolling="no" title="Latihan2akhirsptldv" src="https://www.geogebra.org/material/iframe/id/a5gudstq/width/810/height/717/border/888888/sfsb/true/smb/false/stb/false/stbh/false/ai/false/asb/false/sri/false/rc/false/ld/true/sdz/true/ctl/false" width="810px" height="700px" allowFullScreen
																					/>
																					</div>
																				</>
																			) : null}
																		</>
																	) : null}
																</li>
															</>
														) : null}
													</>
												) : null}
											</li>
										</ol>
									</div>
								</div>
							) : null}
						</div>
					</div>
				) : null}

				<div>
					<div className="d-grid gap-2">
						<button
							onClick={() => clickSetChSoal3()}
							className="btn btn-outline-primary btn-sm mt-2"
						>
							{" "}
							<h6
								style={{
									animation: "scrollTop 0.3s alternate ease infinite",
								}}
							>
								Latihan Soal 3
							</h6>
						</button>
					</div>
					{chsoal3 ? (
						<div
							style={{
								margin: "auto",
								lineHeight: "35px",
								textAlign: "justify",
								width: "100%",
								borderStyle: "inset",
								borderColor: "green",
								borderRadius: "25px",
							}}
							className="mt-2"
						>
							<div
								style={{
									width: "80%",
									margin: "auto",
								}}
							>
								<p style={{fontSize:`${ukuranP}px`}} className="text-center">
									Tentukanlah sistem pertidaksamaan untuk dearah yang tidak
									diarsir pada gambar di bawah ini
								</p>
								<div className="d-flex justify-content-center">
									<MediaQuery minWidth={476} maxWidth={1824}>
										<Iframe
scrolling="no" title="Ch3Part3" src="https://www.geogebra.org/material/iframe/id/hpkpfz5p/width/500/height/400/border/888888/sfsb/true/smb/false/stb/false/stbh/false/ai/false/asb/false/sri/false/rc/false/ld/true/sdz/true/ctl/false" width="500px" height="400px"
allowFullScreen/>
									</MediaQuery>
									<MediaQuery maxWidth={475}>
										<Iframe
scrolling="no" title="Ch3Part3" src="https://www.geogebra.org/material/iframe/id/hpkpfz5p/width/500/height/400/border/888888/sfsb/true/smb/false/stb/false/stbh/false/ai/false/asb/false/sri/false/rc/false/ld/true/sdz/true/ctl/false"
											width="100%"
											style={{ height: "300px", border: "0px" }}
											allowFullScreen	/>
									</MediaQuery>
								</div>
								<div
									style={{
										color: "green",
										display: "flex",
										justifyContent: "space-between",
										width: "10%",
									}}
								>
									<div
										style={{
											width: "5px",
											height: "5px",
											animation: "scrollTop 0.3s alternate ease infinite",
										}}
									>
										<SkipNextIcon />
									</div>
									<p
										style={{ marginLeft: "22px", cursor: "pointer" }}
										onClick={clickSetJawaban3}
									>
										<strong>
											<u>Jawaban</u>
										</strong>
									</p>
									<div
										style={{
											width: "5px",
											height: "5px",
											animation: "scrollTop 0.3s alternate ease infinite",
										}}
									>
										<SkipPreviousIcon />
									</div>
								</div>
								{jawaban3 ? (
									<div
										style={{
											width: "85%",
											margin: "auto",
											textAlign: "justify",
											fontSize:`${ukuranP}px`
										}}
									>
										<p>
											Untuk menentukan sistem pertidaksamaan pada gambar diatas,
											harus ditentukan terlebih dahulu persamaan garis lurus
											yang menjadi batas-batas daerahnya, yakni dengan
											menggunakan rumus :{" "}
										</p>
										<div
											style={{
												display: "flex",
												justifyContent: "space-between",
												width: "60%",
												margin: "auto",
											}}
										>
											<>
												<table
													style={{
														border: "2px solid green",
														borderCollapse: "collapse",
														width: "30%",
														textAlign: "center",
													}}
												>
													<tr>
														<td
															style={{
																border: "2px solid green",
																borderCollapse: "collapse",
															}}
														>
															<InlineMath math="x2" />
														</td>
														<td
															style={{
																border: "2px solid green",
																borderCollapse: "collapse",
															}}
														>
															<InlineMath math="x1" />
														</td>
													</tr>
													<tr>
														<td
															style={{
																border: "2px solid green",
																borderCollapse: "collapse",
															}}
														>
															<InlineMath math="y2" />
														</td>
														<td
															style={{
																border: "2px solid green",
																borderCollapse: "collapse",
															}}
														>
															<InlineMath math="y1" />
														</td>
													</tr>
												</table>
											</>
											<div>
												<DoubleArrowIcon
													style={{
														width: "40px",
														height: "60px",
														color: "green",
													}}
												/>
											</div>
											<div>
												<InlineMath math=" \frac {y-y1} {y2-y1} = \frac {x-x1} {x2-x1} " />
											</div>
										</div>

										<ol>
											<li>Pertama kita ambil dahulu titik potong yang berwarna <b>biru</b> pada sumbu <InlineMath math="\space x \space"/> dan pada sumbu <InlineMath math="\space y \space"/> yang tertera pada grafik soal. Coba kamu lengkapi dulu tabel di bawah ini!</li>
											<div class="d-flex justify-content-center mb-2">
												<table
													style={{
														border: "2px solid green",
														borderCollapse: "collapse",
														width: "30%",
														textAlign: "center",
													}}
												>
													<tr>
														<td
															style={{
																border: "2px solid green",
																borderCollapse: "collapse",
															}}
														>
															<InlineMath math="x" />
														</td>
														<td
															style={{
																border: "2px solid green",
																borderCollapse: "collapse",
															}}
														>
															{/* 4 */}
															<input
																type="text"
																onChange={handthree1}
																style={three1}
															/>
														</td>
														<td
															style={{
																border: "2px solid green",
																borderCollapse: "collapse",
															}}
														>
															{/* 0 */}
															<input
																type="text"
																onChange={handthree2}
																style={three2}
															/>
														</td>
													</tr>
													<tr>
														<td
															style={{
																border: "2px solid green",
																borderCollapse: "collapse",
															}}
														>
															<InlineMath math="y" />
														</td>
														<td
															style={{
																border: "2px solid green",
																borderCollapse: "collapse",
															}}
														>
															{/* 6 */}
															<input
																type="text"
																onChange={handthree3}
																style={three3}
															/>
														</td>
														<td
															style={{
																border: "2px solid green",
																borderCollapse: "collapse",
															}}
														>
															{/* 0 */}
															<input
																type="text"
																onChange={handthree4}
																style={three4}
															/>
														</td>
													</tr>
												</table>
											</div>
								{true1&&true2?
								<>
								<p>Dengan menggunakan rumus yang ada di atas sebelum kalian memasukkan tabel, kita mendapatkan bahwa :</p>
											<div className="text-center"><InlineMath math="x2 = 4"/></div>
											<div className="text-center"><InlineMath math="x1 = 0"/></div>
											<div className="text-center"><InlineMath math="y2 = 0"/></div>
											<div className="text-center"><InlineMath math="y1 = 6"/></div>
											<p>Maka kalian dapat memasukkannya pada rumus, seperti di bawah ini : <i className="alert alert-warning">lengkapi form yang kosong</i></p>
											<ul>
												<li style={{ marginBottom: "4px" }}>
													<InlineMath math="\dfrac {y-6}{0-6} = \dfrac {x-0} {4-0}" />
												</li>
												<li className="mt-2 mb-1">
													<InlineMath math="\dfrac {y-6}{-6} = \dfrac {x} {4}" />
												</li>
												<li>Selanjutnya kita kali silang, maka :</li>
												<li>
													<InlineMath math="4(y - 6) = -6x" />
												</li>
												<li>
													<InlineMath math="4y - 24 = -6x" />
												</li>
												<li>
													<InlineMath math="6x + 4y = " /><input type="text" onChange={handthree5} style={three5} />											
												</li>
												<li>
												<input
														type="text"
														onChange={handthreenew1}
														style={threenew1}
													/>x &nbsp;&nbsp; +
													<input
														type="text"
														onChange={handthreenew2}
														style={threenew2}
													/>y &nbsp;&nbsp; =
													<input
														type="text"
														onChange={handthreenew3}
														style={threenew3}
													/>
												</li>
											</ul>
							{true3&&true4&&true5&&true6?
							<>
								<p className="alert alert-success mt-2">Dan kalian telah mendapatkan satu pertidaksamaan</p>
								<li>Selanjutnya kita ambil dahulu titik potong yang berwarna <b>merah</b> pada sumbu <InlineMath math="\space x \space"/> dan pada sumbu <InlineMath math="\space y \space"/> yang tertera pada grafik soal. Coba kamu lengkapi dulu tabel di bawah ini!</li>
											<div class="d-flex justify-content-center mb-2">
												<table
													style={{
														border: "2px solid green",
														borderCollapse: "collapse",
														width: "30%",
														textAlign: "center",
													}}
												>
													<tr>
														<td
															style={{
																border: "2px solid green",
																borderCollapse: "collapse",
															}}
														>
															<InlineMath math="x" />
														</td>
														<td
															style={{
																border: "2px solid green",
																borderCollapse: "collapse",
															}}
														>
																<input
																type="text"
																onChange={handthree7}
																style={three7}
															/>
														</td>
														<td
															style={{
																border: "2px solid green",
																borderCollapse: "collapse",
															}}
														>
															<input
																type="text"
																onChange={handthree6}
																style={three6}
															/>
														
														</td>
													</tr>
													<tr>
														<td
															style={{
																border: "2px solid green",
																borderCollapse: "collapse",
															}}
														>
															<InlineMath math="y" />
														</td>
														<td
															style={{
																border: "2px solid green",
																borderCollapse: "collapse",
															}}
														>
																<input
																type="text"
																onChange={handthree9}
																style={three9}
															/>
														</td>
														<td
															style={{
																border: "2px solid green",
																borderCollapse: "collapse",
															}}
														>
															<input
																type="text"
																onChange={handthree8}
																style={three8}
															/>
														
														</td>
													</tr>
												</table>
											</div>
								{true7&&true8&&true9&&true10?
								<>
								<p>Dengan menggunakan rumus yang ada di atas sebelum kalian memasukkan tabel, kita mendapatkan bahwa :</p>
											<div className="text-center"><InlineMath math="x2 = 8"/></div>
											<div className="text-center"><InlineMath math="x1 = 0"/></div>
											<div className="text-center"><InlineMath math="y2 = 0"/></div>
											<div className="text-center"><InlineMath math="y1 = 4"/></div>
											<p>Maka kalian dapat memasukkannya pada rumus, seperti di bawah ini : <i className="alert alert-warning">lengkapi form yang kosong</i></p>
											<ul>
												<li style={{ marginBottom: "4px" }}>
													<InlineMath math="\dfrac {y-4}{0-4} = \dfrac {x-0} {8-0}" />
												</li>
												<li>
													<InlineMath math="\dfrac {y-4}{-4} = \dfrac {x} {8}" />
												</li>
												<li>Selanjutnya kita kali silang, maka :</li>
												<li>
													<InlineMath math="8(y - 4) = -4x" />
												</li>
												<li>
													<InlineMath math="8y - 32 = -4x" />
												</li>
												<li>
													<InlineMath math="4x + 8y = " /><input
														type="text"
														onChange={handthree10}
														style={three10}
													/>
												</li>
												<li>
													<InlineMath math="x + " />
													<input
														type="text"
														onChange={handthree11}
														style={three11}
													/><InlineMath math="y =" />
													<input
														type="text"
														onChange={handthree12}
														style={three12}
													/>
												</li>
											</ul>
									
										
								</>
								:null}
										
							</>
							:null}
								</>
								:null}
											

										</ol>

										{show4&&show5&&show6 ? (
											<div>
										<p className="alert alert-success mt-2">Dan kalian telah mendapatkan dua pertidaksamaan</p>
										<li>
												Langkah terakhir substitusikan titik koordinat (0,0) untuk memastikan bahwa bernilai
												benar.
											</li>
										<p className="alert alert-warning">Lengkapi form dengan memasukkan kata <b>Benar</b> atau <b>Salah</b></p>
											<ul>
												<li>
													Substitusikan{" "}
													<InlineMath math="(0,0)\space ke \space  3x + 2y ≤ 12" />{" "}
													, maka :
												</li>
												<ul>
													<li>
														<InlineMath math="3(0) + 2(0) ≤ 12 ." />
													</li>
													<li>
														<InlineMath math="0 ≤ 12 ." />
													</li>
												</ul>
												<li><input type="text" onChange={handthree13} style={three13} /></li>

												<li>
													Substitusikan{" "}
													<InlineMath math="(0,0)\space ke \space x + 2y ≤ 8" />{" "}
													, maka :
												</li>
												<ul>
													<li>
														<InlineMath math="(0)+ 2(0) ≤ 8 ." />
													</li>
													<li>
														<InlineMath math=" 0 ≤ 8 ." />
													</li>
												</ul>
												<li><input type="text" onChange={handthree14} style={three14} /></li>
											</ul>
											{show7&&show8?
											<>
												<p>
													Maka dapat dituliskan bahwa pertidaksamaan yang
													daerahnya tidak diarsir pada daerah penyelesaian
													adalah <InlineMath math=" 3x + 2y ≤ 12 \space" /> dan{" "}
													<InlineMath math=" x + 2y ≤ 8. \space" />
													Sehingga sistem pertidaksamaan linear untuk gambar di
													atas adalah :
												</p>
												<b>
													<MathComponent
														tex={String.raw` 3x + 2y ≤ 12 ; x + 2y ≤ 8 `}
													/>{" "}
												</b>
											</>
											:null}
											</div>
										) : null}
									</div>
								) : null}
							</div>
						</div>
					) : null}
				</div>

				<div className="d-grid gap-2">
					<button
						onClick={() => clickSetChSoal4()}
						className="btn btn-outline-success btn-sm mt-2"
					>
						{" "}
						<h6
							style={{
								animation: "scrollTop 0.3s alternate ease infinite",
							}}
						>
							Latihan Soal 4
						</h6>
					</button>
				</div>

				{chsoal4 ? (
					<div>
						<Ch4 ukuranH={ukuranH} ukuranP={ukuranP} />
					</div>
				) : null}
			</div>
		</div>
	);
};

export default Part3;
